export type CurrencyCode =
  'EUR' | 'BGN' | 'BRL' | 'RUB' | 'RON' | 'JPY' | 'GBP' | 'HRK' | 'HUF' | 'HKD' | 'PHP' | 'PLN' | 'ZAR' | 'MYR' | 'MXN' | 'ILS' | 'NOK' |
  'NZD' | 'CHF' | 'CNY' | 'CAD' | 'CZK' | 'KRW' | 'SGD' | 'SEK' | 'DKK' | 'USD' | 'TRY' | 'THB' | 'AUD' | 'INR' | 'IDR';

export type CurrencySelectionValue = CurrencyCode | null;
